/* eslint-disable react/no-this-in-sfc */
import React from 'react';
import { Tabs } from 'antd';
import Layout from '../../components/layout/Layout';
import FilterSidebar from '../../components/FilterSidebar';
import FilterForm from './FilterForm';
import './assets.scss';
import TagsTab from './tabs/TagsTab';

const { TabPane } = Tabs;

export default function () {
    const { currentTabKey } = this.state;
    const {
        user,
        asset,
        isFetchingDivision,
        companyTags,
        actions,
        fetchingTags,
        tagsTabFilters,
    } = this.props;

    const isLoading = asset?.isFetching?.length > 0 || isFetchingDivision || fetchingTags;

    let tabIdentifier;
    switch (currentTabKey) {
        case '1':
            tabIdentifier = 'asset';
            break;
        case '2':
            tabIdentifier = 'division';
            break;
        case '3':
            tabIdentifier = 'tag';
            break;
        default:
            tabIdentifier = 'assets';
            break;
    }

    return (
        <Layout
            data-test="pages-assets"
            className="assets"
            title={<div>Assets</div>}
            headerTitle={<div>Assets Page</div>}
            showFooter={false}
            loading={isLoading}
        >
            <div className={`content-wrap${user?.userCompany?.current_alert ? '-with-banner' : ''}`}>
                <FilterSidebar displayFilter>
                    <FilterForm
                        key={`filter_form_${currentTabKey}`}
                        type={tabIdentifier}
                        onSubmit={(filterData) => {
                            switch (currentTabKey) {
                                case '1':
                                    this.filterAssets(filterData);
                                    break;
                                case '2':
                                    this.filterDivisions(filterData);
                                    break;
                                case '3':
                                    this.filterTags(filterData);
                                    break;
                                default:
                                    throw new Error('Unknown tab key');
                            }
                        }}
                    />
                </FilterSidebar>
                <div 
                    className="content" 
                    style={{ opacity: isLoading ? 0 : 1 }}
                >
                    <div 
                        className="content-inner"
                        style={{ paddingLeft: currentTabKey === '3' ? '0px' : '16px' }}
                    >
                        <section className="section">
                            <Tabs
                                onTabClick={this.handleTabChange}
                                defaultActiveKey={currentTabKey}
                                activeKey={currentTabKey}
                                animated={false}
                                className="tabs-restyled"
                                stlyle={{ maxWidth: '40%' }}
                                data-testid="assets_subtab-navigation"
                            >
                                <TabPane
                                    tab="Assets"
                                    key="1"
                                    data-testid="assets_subtab-navigation_assets"
                                >
                                    <div className="section__body">
                                        {currentTabKey === '1' ? this.assetTabContent() : null}
                                    </div>
                                </TabPane>
                                <TabPane
                                    tab="Divisions"
                                    key="2"
                                    data-testid="assets_subtab-navigation_divisions"
                                >
                                    <div className="section__body">
                                        {currentTabKey === '2' ? this.divisionTabContent() : null}
                                    </div>
                                </TabPane>
                                <TabPane 
                                    tab="Tags" 
                                    key="3" 
                                    data-testid="assets_subtab-navigation_tags"
                                >
                                    <TagsTab
                                        tags={companyTags?.filteredTagList || []}
                                        onCreateTag={actions.createTagRequest}
                                        onDeleteTag={actions.deleteTagRequest}
                                        setCurrentTabKey={this.handleTabChange}
                                        tagsPagination={companyTags.pagination}
                                        onPaginationChange={(page) => {
                                            actions.filterCompanyTagsRequest({ 
                                                page, 
                                                searchParams: tagsTabFilters 
                                            });
                                        }}
                                    />
                                </TabPane>
                            </Tabs>
                        </section>
                    </div>
                </div>
            </div>
        </Layout>
    );
}
